<template>
  <el-dialog width="1250px":modal-append-to-body="false" :visible.sync="visible" :title="!dataForm.id ? '新增税源地' : '修改税源地'" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form style="padding-right: 20px;" :model="dataForm" :rules="dataRule" ref="dataForm" :label-width="$i18n.locale === 'en-US' ? '200px' : '200px'">

		<el-row>
			<el-row>

				<el-col :span="12">
					<el-form-item label="法人身份证正反面：">
						<template slot="label">
							<!-- <span style="color: #f56c6c;margin-right: 4px;">*</span> -->
							 法人身份证正反面：
						</template>
						<el-row>
							<el-col :span="12">
								<el-form-item prop="legalPersonIdcardFace">
									<el-upload
											ref="upload"
											:action="url"
											class="avatar-uploader"
											:before-upload="beforeUploadHandle"
											:on-success="beforesuccessHandle"
											:on-error="backerror"
											:auto-upload="true"
											:show-file-list="false"
											style="width: 164px;height: 117px;line-height: 106px !important;"
									>
										<img style="width: 164px;height: 117px;line-height: 106px !important;" v-if="dataForm.legalPersonIdcardFace" :src="dataForm.legalPersonIdcardFace" class="avatar">
										<i v-else style="width: 164px;height: 117px;line-height: 106px !important;"  :style="{backgroundImage:'url('+require('../../../assets/img/cardFront.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}" class="el-icon-circle-plus avatar-uploader-icon"></i>

									</el-upload>

								</el-form-item>
							</el-col>
							<el-col :span="12" >
								<el-form-item prop="legalPersonIdcardBack">
									<el-upload
											ref="upload"
											:action="url"
											class="avatar-uploader"
											:before-upload="beforeUploadHandle"
											:on-success="backsuccessHandle"
											:on-error="backerror"
											:auto-upload="true"
											:show-file-list="false"
											style="width: 164px;height: 117px;line-height: 106px !important;margin-left: 32px;"
									>
										<img style="width: 164px;height: 117px;line-height: 106px !important;" v-if="dataForm.legalPersonIdcardBack" :src="dataForm.legalPersonIdcardBack" class="avatar">
										<i v-else style="width: 164px;height: 117px;line-height: 106px !important;" :style="{backgroundImage:'url('+require('../../../assets/img/cardBack.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}" class="el-icon-circle-plus avatar-uploader-icon"></i>
									</el-upload>

								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="办税人员身份证正反面：">
						<template slot="label">
							<!--<span style="color: #f56c6c;margin-right: 4px;">*</span> 办税人员身份证正反面：-->
							办税人员身份证正反面：
						</template>
						<el-row>
							<el-col :span="12">
								<el-form-item >
									<el-upload
											ref="upload"
											:action="url"
											class="avatar-uploader"
											:before-upload="beforeUploadHandle"
											:on-success="legalbeforesuccessHandle"
											:on-error="backerror"
											:auto-upload="true"
											:show-file-list="false"
											style="width: 164px;height: 117px;line-height: 106px !important;"
									>
										<img style="width: 164px;height: 117px;line-height: 106px !important;" v-if="dataForm.taxOfficerIdcardFace" :src="dataForm.taxOfficerIdcardFace" class="avatar">
										<i v-else style="width: 164px;height: 117px;line-height: 106px !important;" :style="{backgroundImage:'url('+require('../../../assets/img/cardFront.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}" class="el-icon-circle-plus avatar-uploader-icon"></i>
									</el-upload>

								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item >
									<el-upload
											ref="upload"
											:action="url"
											class="avatar-uploader"
											:before-upload="beforeUploadHandle"
											:on-success="legalbacksuccessHandle"
											:on-error="backerror"
											:auto-upload="true"
											:show-file-list="false"
											style="width: 164px;height: 117px;line-height: 106px !important;margin-left: 32px;"
									>
										<img style="width: 164px;height: 117px;line-height: 106px !important;" v-if="dataForm.taxOfficerIdcardBack" :src="dataForm.taxOfficerIdcardBack" class="avatar">
										<i v-else style="width: 164px;height: 117px;line-height: 106px !important;" :style="{backgroundImage:'url('+require('../../../assets/img/cardBack.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}" class="el-icon-circle-plus avatar-uploader-icon"></i>
									</el-upload>

								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="企业营业执照照片：" prop="businessLicense">
						<el-upload
								ref="upload"
								:action="url"
								class="avatar-uploader"
								:before-upload="beforeUploadHandle"
								:on-success="beforesuccessbusinessLicense"
								:on-error="backerror"
								:auto-upload="true"
								:show-file-list="false"
								style="width: 162px;height: 104px;line-height: 94px !important;"
						>
							<img style="width: 162px;height: 104px;line-height: 94px !important;" v-if="dataForm.businessLicense" :src="dataForm.businessLicense" class="avatar">
							<i v-else style="width: 162px;height: 104px;line-height: 94px !important;" :style="{backgroundImage:'url('+require('../../../assets/img/yingye.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}" class="el-icon-circle-plus avatar-uploader-icon"></i>
						</el-upload>

					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="企业资质：" >
						<el-row>
							<el-col v-if="certificates.length > 0" :span="10">
								<img v-for="(item,index) in certificates" style="width: 162px;height: 104px;line-height: 94px !important;" :src="item" class="avatar">
							</el-col>
							<el-col :span="10">
								<el-upload
										ref="upload"
										:action="url"
										class="avatar-uploader"
										:before-upload="beforeUploadHandle"
										:on-success="backsuccesscertificates"
										:on-error="backerror"
										:auto-upload="true"
										:show-file-list="false"
										style="width: 100%;height: 115px;"
								>
									<i style="width: 162px;height: 104px;line-height: 94px !important;" :style="{backgroundImage:'url('+require('../../../assets/img/yingye.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}" class="el-icon-circle-plus avatar-uploader-icon"></i>

								</el-upload>
							</el-col>
							<el-col :span="4" v-if="certificates.length > 0" >
								<img :src="require('../../../assets/img/more.png')" @click="showmsg()" style="width: 30px;height: 30px;"/>
							</el-col>
						</el-row>
					</el-form-item>
				</el-col>
			</el-row>
			<el-col :span="12">
				<el-form-item label="经营范围：" prop="businessScope">
					<el-input v-model="dataForm.businessScope"  maxlength="500" :autosize="{ minRows: 6, maxRows: 6}" show-word-limit type="textarea" placeholder="经营范围" style="border: none"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="企业简介：" prop="intro">
					<el-input v-model="dataForm.intro"  maxlength="500" :autosize="{ minRows: 6, maxRows: 6}"  show-word-limit type="textarea" placeholder="企业简介" style="border: none"></el-input>
				</el-form-item>
			</el-col>

		</el-row>
		<el-row>
			<el-col :span="12">
				<el-form-item label="税源地" prop="bodyName">
				  <el-input v-model="dataForm.bodyName" maxlength="128"  placeholder="税源地"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="税源地简称" prop="abbreviation">
				  <el-input v-model="dataForm.abbreviation" maxlength="128"  placeholder="税源地简称"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="社会信用代码" prop="taxCode">
				    <el-input v-model="dataForm.taxCode" placeholder="社会信用代码"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="开户行" prop="bankName">
				    <el-input v-model="dataForm.bankName" placeholder="开户行"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="开户账号" prop="bankAccount">
				    <el-input v-model="dataForm.bankAccount" placeholder="开户账号"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="注册地址" prop="address">
				    <el-input v-model="dataForm.address" placeholder="注册地址"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="联系电话" prop="phone">
				    <el-input v-model="dataForm.phone" placeholder="联系电话"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="法人姓名：" prop="legalPersonName">
				    <el-input v-model="dataForm.legalPersonName" placeholder="法人姓名"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="办税人员姓名：" >
				    <el-input v-model="dataForm.taxOfficerName" placeholder="办税人员姓名"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="法人身份证号：" prop="legalPersonIdcard">
				    <el-input v-model="dataForm.legalPersonIdcard" placeholder="法人身份证号"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="办税人员身份证号：" >
				    <el-input v-model="dataForm.taxOfficerIdcard" placeholder="办税人员身份证"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="法人手机号：" prop="legalPersonPhone">
				    <el-input v-model="dataForm.legalPersonPhone" placeholder="法人手机号"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="办税人员手机号：" >
				    <el-input v-model="dataForm.taxOfficerPhone" placeholder="办税人员手机号"></el-input>
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
        	<el-col :span="12">
        		<el-form-item prop="companyScale" label="企业规模">
        		    <ren-radio-group v-model="dataForm.companyScale" dict-type="companyScale"></ren-radio-group>
        		</el-form-item>
        	</el-col>
		
        	<el-col :span="12">
        		<el-form-item prop="isEnable" label="状态">
        		    <ren-radio-group v-model="dataForm.isEnable" dict-type="isEnable"></ren-radio-group>
        		</el-form-item>
        	</el-col>
        </el-row>

      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()":loading="loadingbut">{{ $t('confirm') }}</el-button>
    </template>
	<el-dialog :modal-append-to-body="true" :append-to-body="true" :modal="false" title="企业资质" width="700px" custom-class="dialogBg" :show-close="false" top="264px" center :visible.sync="dialogVisible">

		<el-row>
			<el-col v-for="(item,index) in certificates" :key="index" :offset="1" v-if="certificates.length > 0" :span="8" style="text-align: center;">
				<img style="width: 130px;height: 115px;margin:10px auto;" @click="yulan(item)" :src="item" class="avatar">
				<el-button type="text" size="small" @click="deleteimg(index)">删除</el-button>
			</el-col>
		</el-row>
		<template slot="footer">
		  <el-button @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
		</template>
	</el-dialog>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
import ossUploadImg from '../oss/oss-upload-img'
export default {
  components: {
    ossUploadImg
  },
  data () {
    return {
      visible: false,
	  loadingbut: false,
	  url: `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
	  certificates: [],
	  dialogVisible: false,
      dataForm: {
        id: '',
        intro: '',
        businessScope: '',
        legalPersonName: '',
        legalPersonPhone: '',
        legalPersonIdcard: '',
        taxOfficerName: '',
        taxOfficerPhone: '',
        taxOfficerIdcard: '',
        bodyName: '',
		abbreviation:'',
        bodyCode: '',
        taxCode: '',
        bankName: '',
        bankAccount: '',
        address: '',
        phone: '',
        companyScale: '',
        isEnable: 1,
        legalPersonIdcardBack: '',
        legalPersonIdcardFace: '',
        taxOfficerIdcardBack: '',
        taxOfficerIdcardFace: '',
        certificates: '',
        businessLicense: ''
      }
    }
  },
  computed: {

    dataRule () {
		var checkName = (rule, value, callback) => {
		    if(!value){
                callback('必填项不能为空')
			}
			// else if(value.indexOf('（') > -1 || value.indexOf('）') > -1 ){
            //     callback(new Error("检测出符号错误'（'与'）'必须是英文符号格式！"))
			// }
			callback()
		}
      var checknum = (rule, value, callback) => {
        if (!isNumber(value)) {
          callback(new Error('请输入数字值'))
        }
        callback()
      }
      var checkfloat = (rule, value, callback) => {
        if (/^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入大于0的数字值,并且最多两位小数'))
        }
      }
      var checkphone = (rule, value, callback) => {
        if (/^1\d{10}$/.test(value)) {
          callback()
        } else if (/^0\d{2,3}-?\d{7,8}$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入手机号'))
        }
      }
      var checkcard = (rule, value, callback) => {
        if (/^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入身份证号'))
        }
      }
      var checkbank = (rule, value, callback) => {
        if (/^([A-Za-z0-9]{9}|[A-Za-z0-9]{12}|[A-Za-z0-9]{16}|[A-Za-z0-9]{17}|[A-Za-z0-9]{15}|[A-Za-z0-9]{19})$/.test(value)) {
        //   if(/^([1-9]{1})(\d{14}|\d{18})$/.test(value)){
          callback()
        } else {
          callback(new Error('请输入卡号'))
        }
      }

      var checkNumtwo = (rule, value, callback) => {
        if (/^[A-Za-z0-9]{7,20}$/.test(value)) {
          callback()
        } else {
          callback(new Error('社会信用代码格式错误'))
        }
      }
      return {
        isEnable: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        intro: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        businessScope: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // legalPersonName: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // legalPersonPhone: [
        //   { required: true, message: '输入正确的电话号码', validator: checkphone, trigger: 'blur' }
        // ],
        // legalPersonIdcard: [
        //   { required: true, message: '请输入身份证号', validator: checkcard, trigger: 'blur' }
        // ],
        taxOfficerName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taxOfficerPhone: [
          { required: true, message: '输入正确的电话号码', validator: checkphone, trigger: 'blur' }
        ],
        taxOfficerIdcard: [
          { required: true, message: '请输入身份证号', validator: checkcard, trigger: 'blur' }
        ],
        bodyName: [
          { required: true, validator:checkName, trigger: 'blur' }
        ],
		abbreviation:[
			{ required: true, message: this.$t('validate.required'), trigger: 'blur' }
		],
        bodyCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taxCode: [
          { required: true, message: '格式错误，7-20位数字或字母', validator: checkNumtwo, trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankAccount: [{
          required: true,
          message: '请输入卡号',
          trigger: 'blur'
        },{ message: '银行卡号错误，请检查位数'
        ,validator: checkbank,
        trigger: 'blur'}],
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '输入正确的电话号码', validator: checkphone, trigger: 'blur' }
        ],
        companyScale: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // legalPersonIdcardBack: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        legalPersonIdcardFace: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taxOfficerIdcardBack: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taxOfficerIdcardFace: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        certificates: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        businessLicense: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
	  // 上传之前
	  beforeUploadHandle (file) {
		  if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
		    this.$message.error(this.$t('upload.tip', { 'format': 'jpg、png、gif' }))
		    return false
		  }
		  if (file.size / 1024 / 1024 > 30) {
			  this.$message.error('文件太大，只能上传30MB以内的文件')
			  return false
		  }
	  },
	  // 上传成功
	  beforesuccessHandle (data, file) {
	      this.dataForm.legalPersonIdcardFace = data.data.url
          let imgUrl = data.data.url;
		  const loading = this.$loading({
			lock: true,
			text: '正在识别身份证...',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
		  })
          this.$http.post('/sys/plat/info/ca/idcardOCR',{imageUrl:imgUrl}).then(({ data: res })=>{
			  loading.close()
              if(res.code == 0){
			  this.dataForm.legalPersonName = res.data.name;
			  this.dataForm.legalPersonIdcard = res.data.idNum;
			  this.$message.success('身份证识别成功')
		  } else {
			  this.$message.error(res.msg || '身份证识别失败')
		  }
		  }).catch(error => {
			  loading.close()
			  console.error('身份证识别错误:', error)
			  this.$message.error('身份证识别失败，请重试')
		  })
	  },
	  backsuccessHandle (data, file) {
	      this.dataForm.legalPersonIdcardBack = data.data.url;
	  },
	  legalbeforesuccessHandle (data, file) {
	      this.dataForm.taxOfficerIdcardFace = data.data.url
          let imgUrl = data.data.url;
		  const loading = this.$loading({
			lock: true,
			text: '正在识别身份证...',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
		  })
          this.$http.post('/sys/plat/info/ca/idcardOCR',{imageUrl:imgUrl}).then(({ data: res })=>{
			  loading.close()
              if(res.code == 0){
			  this.dataForm.taxOfficerName = res.data.name;
			  this.dataForm.taxOfficerIdcard = res.data.idNum;
			  this.$message.success('身份证识别成功')
		  } else {
			  this.$message.error(res.msg || '身份证识别失败')
		  }
		  }).catch(error => {
			  loading.close()
			  console.error('身份证识别错误:', error)
			  this.$message.error('身份证识别失败，请重试')
		  })
	  },
	  legalbacksuccessHandle (data, file) {
	      this.dataForm.taxOfficerIdcardBack = data.data.url
	  },

//企业营业执照
	  beforesuccessbusinessLicense (data, file) {
	      this.dataForm.businessLicense = data.data.url
          let imgUrl = data.data.url
          this.$http.post('/sys/plat/info/ca/bizLicenseOcr',{imageUrl:imgUrl}).then(({ data: res })=>{
	          if(res.code == 0){
				  let LicenseInfo = res.data,
					  formInfo = this.dataForm;
//				  经营范围
                  formInfo.businessScope = LicenseInfo.business
//				  税源地
                  formInfo.bodyName = LicenseInfo.name
//				  社会信用代码
                  formInfo.taxCode = LicenseInfo.regNum
//				  注册地址
                  formInfo.address = LicenseInfo.address
//				  法人姓名
                  formInfo.legalPersonName = LicenseInfo.person

              }
		  })
	  },
	  backsuccesscertificates (data, file) {
	      // this.dataForm.certificates.push(data.data.url);
		  this.certificates.push(data.data.url)
		  this.dataForm.certificates = this.certificates.join(',')
	  },
	  backerror (e) {
      this.$message.error('文件上传失败，请重试')
	  },
	  deleteimg (index) {
		  this.certificates.splice(index, 1)
		  this.dataForm.certificates = this.certificates.join(',')
	  },
	  showmsg () {
      this.dialogVisible = true
	  },
    init () {
      this.visible = true
      this.$nextTick(() => {
		  this.certificates = []
		  this.dataForm.certificates = ''
		  this.dataForm.taxOfficerIdcardFace = ''
		  this.dataForm.taxOfficerIdcardBack = ''
		  this.dataForm.taxOfficerName = ''
		  this.dataForm.legalPersonIdcard = ''
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    yulan (url) {
      window.open(url, url)
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/plat/body/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.certificates = this.dataForm.certificates ? this.dataForm.certificates.split(',') : []
		console.log(this.certificates)
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
		// this.dataForm.bodyName = this.dataForm.bodyName.replace('（','(');
		// this.dataForm.bodyName = this.dataForm.bodyName.replace('）',')');
        this.loadingbut = true
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/plat/body/', this.dataForm).then(({ data: res }) => {
          this.loadingbut = false
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>